import { render, staticRenderFns } from "./WordpressConfig.vue?vue&type=template&id=53015f01"
import script from "./WordpressConfig.vue?vue&type=script&lang=js"
export * from "./WordpressConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports